import HeaderCompact from './HeaderCompact.js'

export default HeaderCompact
